const I18N = (wordkey, language) => {
  const translations = {
    please_select: {
      de: "Bitte auswählen",
      en: "Please select",
      ar: "يرجى الإختيار",
    },
    submit: {
      de: "Formular abschicken",
      en: "Submit form",
      ar: "إرسال الإستمارة",
    },
    optional: {
      de: "Diese Frage ist optional",
      en: "This question is not mandatory",
      ar: "الجواب على هذا السؤال غير إلزامي",
    },
    form_not_complete: {
      de: "Sie müssen alle Pflichtfelder ausfüllen (rot markiert).",
      en: "Please fill in all mandatory fields (marked red).",
      ar: "يرجى الجواب على جميع الأسئلة الإلزامية الملونة لاللونن الأحمر",
    },
    thanks_for_submitting: {
      de: "Ihre Antworten sind angekommen. Vielen Dank für Ihr Feedback!",
      en: "We received your response. Thank you for your Feedback.",
      ar: "تم إرسال أجوبتكم. شكراً لكم",
    },
  };
  const tkey = wordkey;

  let translation = translations.hasOwnProperty(tkey)
    ? translations[tkey][language]
    : `***${tkey}***`;

  return translation;
};

export default I18N;
